import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import formatPhoneNumber from '../util/format-phone-number'


function ContactForm(props) {
  const {data, actions, showErrors} = props

  const {
    firstName,
    lastName,
    jobTitle,
    phone,
    email,
    _errors
  } = data.contact

  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom>
        Your Contact Info
      </Typography>

      <Grid container spacing={24}>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="firstName"
            error={showErrors && !!_errors.firstName}
            value={firstName || ''}
            onChange={e => actions.updateContact({firstName: e.target.value})}
            name="firstName"
            label="First name"
            fullWidth
            autoComplete="name fname"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="lastName"
            error={showErrors && !!_errors.lastName}
            value={lastName || ''}
            onChange={e => actions.updateContact({lastName: e.target.value})}
            name="lastName"
            label="Last name"
            fullWidth
            autoComplete="name lname"
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            required
            id="jobTitle"
            error={showErrors && !!_errors.jobTitle}
            value={jobTitle || ''}
            onChange={e => actions.updateContact({jobTitle: e.target.value})}
            name="jobTitle"
            label="Job Title"
            fullWidth
            autoComplete="organization title"
          />

          {/* <FormControl fullWidth>
            <InputLabel htmlFor="job-title">Job Title</InputLabel>
            <NativeSelect
              // value={this.state.age || ''}
              // onChange={this.handleChange('age')}
              // inputProps={{
              //   name: 'age',
              //   id: 'job-title',
              // }}
            >
              <option value="" />
              <option value="accountant">Accountant/Bookkeeper</option>
              <option value="owner">Owner/President</option>
              <option value="service">Service Manager</option>
              <option value="trainer">Training Coordinator</option>
              <option value="other">Other</option>
            </NativeSelect>
          </FormControl> */}
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="phone"
            error={showErrors && !!_errors.phone}
            value={phone || ''}
            onChange={e => actions.updateContact({phone: formatPhoneNumber(e.target.value)})}
            name="phone"
            label="Phone Number"
            fullWidth
            autoComplete="tel"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="email"
            error={showErrors && !!_errors.email}
            value={email || ''}
            onChange={e => actions.updateContact({email: e.target.value})}
            name="email"
            label="Email Address"
            fullWidth
            autoComplete="email"
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default ContactForm;